import { render, staticRenderFns } from "./Bind.vue?vue&type=template&id=18fa79aa&"
import script from "./Bind.vue?vue&type=script&lang=js&"
export * from "./Bind.vue?vue&type=script&lang=js&"
import style0 from "./Bind.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports